interface IProp {
  className?: string
}

const Tarpoline = (props: IProp) => {
  const { className = 'fill-none stroke-black' } = props

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2241 16.9973H4.28125C3.72897 16.9973 3.28125 16.5496 3.28125 15.9973V8.96875C3.28125 8.41647 3.72896 7.96875 4.28125 7.96875H13.767C14.3192 7.96875 14.767 8.41647 14.767 8.96875V13.1687M11.2241 16.9973V14.1688C11.2241 13.6165 11.6718 13.1687 12.2241 13.1687H14.767M11.2241 16.9973L14.767 13.1687"
        className={className}
      />
      <circle
        cx="5.61741"
        cy="10.2112"
        r="0.914286"
        className={className}
        strokeWidth="0.7"
      />
      <g clipPath="url(#clip0_12921_75768)">
        <path
          d="M5.86027 1.35156C5.86027 1.35156 4.70312 2.62362 4.70312 3.52362C4.70312 4.23365 5.15023 4.68076 5.86027 4.68076C6.5703 4.68076 7.01741 4.23365 7.01741 3.52362C7.01741 2.62362 5.86027 1.35156 5.86027 1.35156ZM5.98884 4.2629V4.07004C6.11667 4.0699 6.23921 4.01905 6.3296 3.92866C6.41999 3.83828 6.47083 3.71573 6.47098 3.5879H6.66384C6.66365 3.76686 6.59247 3.93844 6.46592 4.06499C6.33938 4.19153 6.1678 4.26271 5.98884 4.2629Z"
          className={className}
        />
      </g>
      <g clipPath="url(#clip1_12921_75768)">
        <path
          d="M9.00089 3.40625C9.00089 3.40625 7.84375 4.6783 7.84375 5.5783C7.84375 6.28834 8.29086 6.73545 9.00089 6.73545C9.71093 6.73545 10.158 6.28834 10.158 5.5783C10.158 4.6783 9.00089 3.40625 9.00089 3.40625ZM9.12946 6.31759V6.12473C9.25729 6.12458 9.37984 6.07374 9.47023 5.98335C9.56061 5.89296 9.61146 5.77042 9.61161 5.64259H9.80446C9.80427 5.82155 9.7331 5.99313 9.60655 6.11968C9.48 6.24622 9.30843 6.3174 9.12946 6.31759Z"
          className={className}
        />
      </g>
      <g clipPath="url(#clip2_12921_75768)">
        <path
          d="M11.8525 1.35156C11.8525 1.35156 10.6953 2.62362 10.6953 3.52362C10.6953 4.23365 11.1424 4.68076 11.8525 4.68076C12.5625 4.68076 13.0096 4.23365 13.0096 3.52362C13.0096 2.62362 11.8525 1.35156 11.8525 1.35156ZM11.981 4.2629V4.07004C12.1089 4.0699 12.2314 4.01905 12.3218 3.92866C12.4122 3.83828 12.463 3.71573 12.4632 3.5879H12.656C12.6558 3.76686 12.5847 3.93844 12.4581 4.06499C12.3316 4.19153 12.16 4.26271 11.981 4.2629Z"
          className={className}
        />
      </g>
      <defs>
        <clipPath id="clip0_12921_75768">
          <rect
            width="4.11429"
            height="4.11429"
            fill="white"
            transform="translate(3.79688 1)"
          />
        </clipPath>
        <clipPath id="clip1_12921_75768">
          <rect
            width="4.11429"
            height="4.11429"
            fill="white"
            transform="translate(6.94531 3.05469)"
          />
        </clipPath>
        <clipPath id="clip2_12921_75768">
          <rect
            width="4.11429"
            height="4.11429"
            fill="white"
            transform="translate(9.80469 1)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Tarpoline
